import React, { useCallback, useEffect, useState } from "react";
import BreadCumb from "../../Component/BreadCumb";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteEvent, getAllEvent } from "../../Libs/api";
import Loader from "../../Component/Loader";
import Swal from "sweetalert2";
import EditButton from "../../Component/EditButton";
import DeleteButton from "../../Component/DeleteButton";
import { Pagination } from "antd";
import ViewButton from "../../Component/ViewButton";
import AddEvent from "./AddEvent";
import EditEvent from "./EditEvent";
import moment from "moment";
// import ViewContact from "./ViewContact";

const EventList = () => {
  const navigate = useNavigate();
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [loading, setloading] = useState(false);
  const [allEvent, setAllEvent] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const callAPI = useCallback(async (limit, offset) => {
    try {
      setloading(true);
      const apiCall = await getAllEvent({ limit, offset });
      if (apiCall.status) {
        setAllEvent(apiCall?.data?.rows);
        setTotalCount(apiCall?.data?.count);
        setloading(false);
      } else {
        toast.error(apiCall?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    callAPI(limit, offset);
    // eslint-disable-next-line
  }, [callAPI, limit, offset]);

  const handleDelete = async (id) => {
    await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let formData = {
          id: id,
        };

        setloading(true);

        try {
          const apiCall = await deleteEvent(formData);
          if (apiCall.status) {
            console.log(apiCall, "apiCall");

            callAPI(limit, offset);
          } else {
            setloading(false);
            toast.error(apiCall?.message);
          }
        } catch (error) {
          setloading(false);
          console.log(error);
          toast.error(error);
        }
      }
    });
  };

  const handleOnChange = (page) => {
    console.log("page: ", page);
    setOffset(page * limit - limit);
  };

  const handleChangeSize = (current, size) => {
    setOffset(0);
    setLimit(size);
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div class="page-body">
      <BreadCumb title={"Event"} subtitle={"General"} />
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="list-product-header">
                  <div>
                    <Link
                      class="btn btn-primary"
                      onClick={() => {
                        setAddModal(true);
                      }}
                    >
                      <i class="fa fa-plus"></i>Add Event
                    </Link>
                  </div>
                </div>
                <div class="list-product">
                  <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
                    <div class="datatable-container">
                      <table class="table datatable-table" id="project-status">
                        <thead>
                          <tr>
                            <th data-sortable="true" style={{ width: "20%" }}>
                              <span class="f-light f-w-600">Title </span>
                            </th>

                            <th data-sortable="true" style={{ width: "20%" }}>
                              <span class="f-light f-w-600"> Created At </span>
                            </th>

                            <th data-sortable="true" style={{ width: "20%" }}>
                              <span class="f-light f-w-600">Action</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {allEvent?.map((item, i) => {
                            return (
                              <tr key={i} data-index={i}>
                                <td>
                                  <p class="">{item?.title}</p>
                                </td>

                                <td>
                                  <p class="f-light">
                                    {moment(item?.createdAt).format(
                                      "DD-MM-YYYY HH:MM A"
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <div class="product-action">
                                    <EditButton
                                      onClickFunction={() => {
                                        setEditModal(true);
                                        setSingleData(item);
                                      }}
                                    />
                                    <DeleteButton
                                      onClickFunction={() => {
                                        handleDelete(item?.id);
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="mt-4 d-flex justify-content-end">
                  <Pagination
                    defaultCurrent={1}
                    total={totalCount}
                    defaultPageSize={limit}
                    current={offset / limit + 1}
                    onChange={handleOnChange}
                    showSizeChanger={true}
                    onShowSizeChange={handleChangeSize}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {addModal && (
        <AddEvent
          openModal={addModal}
          onSubmit={() => {
            setAddModal(false);
            callAPI(limit, offset);
          }}
          onClose={() => setAddModal(false)}
        />
      )}
      {editModal && (
        <EditEvent
          openModal={editModal}
          singleData={singleData}
          onSubmit={() => {
            setEditModal(false);
            callAPI(limit, offset);
          }}
          onClose={() => setEditModal(false)}
        />
      )}
    </div>
  );
};

export default EventList;
